export default [
  {
    path: '/initial-information-declaration',
    name: 'initialInformationDeclaration',
    component: () => import('@/views/initialInformationDeclaration/InitialInformationDeclaration.vue'),
    meta: {},
  },
];
